import { render, staticRenderFns } from "./CustomerAccountDetailView.vue?vue&type=template&id=53d25909"
import script from "./CustomerAccountDetailView.vue?vue&type=script&lang=js"
export * from "./CustomerAccountDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports